import { Model } from "./model";
import { PublicHoliday } from "./public-holiday";

export class TermExtraDay extends Model {

  constructor(
    public termId?: number,
    public date: Date = null,
    public name: string = null,
    public publicHoliday: PublicHoliday = null
  ) {
    super()
  }

  static clone(obj: any) {
    const o = new this()

    if (obj.termId) { o.termId = obj.termId }
    if (obj.date) { o.date = new Date(obj.date) }
    if (obj.publicHoliday) { o.publicHoliday = PublicHoliday.clone(obj.publicHoliday) }

    return o
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/term-extra-day.ts